const SidebarData = [
    {
        label: "Menu",
        isMainMenu: true,
    },
    {
        label: "Dashboard",
        icon: "mdi mdi-home-variant-outline",
        url: "/dashboard",
        issubMenubadge: true,
    },
    {
        label: "Users",
        icon: "ri-group-line",
        subItem: [
            {
                sublabel: "Users", link: "/users"
            }
        ],
    },
    {
        label: "Clients",
        icon: "ri-community-line",
        subItem: [
            {
                sublabel: "Clients", link: "/clients"
            }
        ],
    },
    {
        label: "Companies",
        icon: "mdi mdi-home-group",
        subItem: [
            {
                sublabel: "Companies", link: "/companies"
            }
        ],
    },
    {
        label: "Projects",
        icon: "ri-stack-fill",
        subItem: [
            {
                sublabel: "All", link: "/projects"
            },
            {
                sublabel: "Categories", link: "/project-categories"
            },
            {
                sublabel: "Mapped users", link: "/mapped-users"
            }
        ],
    },

    {
        label: "Valuations",
        icon: "mdi mdi-chart-line",
        subItem: [
            {
                sublabel: "Assets", link: "/assets-valuation"
            },
            {
                sublabel: "Assets by Category",
                subMenu: [
                    {
                        title: "Buildings", link: "/assets-by-category?category=buildings"
                    },
                    {
                        title: "Equipment", link: "/assets-by-category?category=equipment"
                    },
                    {
                        title: "Furniture", link: "/assets-by-category?category=furniture"
                    },
                    {
                        title: "ICT", link: "/assets-by-category?category=ict"
                    },
                    {
                        title: "Land", link: "/assets-by-category?category=land"
                    },
                    {
                        title: "Machinery", link: "/assets-by-category?category=machinery"
                    },
                    {
                        title: "Vehicles", link: "/assets-by-category?category=vehicles"
                    }
                ]
            },
            {
                sublabel: "Compensation", link: "/compensation-valuation"
            },
            {
                sublabel: "Mortgages", link: "/mortgages-valuation"
            }
        ],
    },
    {
        label: "Security",
        icon: "ri-lock-line",
        subItem: [
            {
                sublabel: "Roles", link: "/roles"
            },
            {
                sublabel: "Permissions", link: "/permissions"
            }
        ],
    },
    {
        label: "Reports",
        icon: "ri-file-list-3-line",
        subItem: [
            {
                sublabel: "Form no.3", link: "/company-profile",
            },
            {
                sublabel: "Form no.4", link: "/form-3"
            }
        ]
    },
    {
        label: "Settings",
        icon: "ri-settings-3-line",
        subItem: [
            {
                sublabel: "Company profile", link: "/company-profile",
            },
            {
                sublabel: "User profile", link: "/userprofile"
            },
            {
                sublabel: "Crop Categories", link: "/crop-categories"
            }
        ]
    },
    {
        label: "Setup",
        isMainMenu: true,
    },
    {
        label: "Configurations",
        icon: "ri-list-settings-line",
        subItem: [
            {
                sublabel: "Crops", link: "/crops-setup"
            },
            {
                sublabel: "Regions", link: "/regions-setup",
            },
            {
                sublabel: "Districts", link: "/districts-setup"
            },
            {
                sublabel: "Councils", link: "/councils-setup"
            },
            {
                sublabel: "Wards", link: "/wards-setup"
            },
            {
                sublabel: "Villages/Mtaa", link: "/villages-setup"
            },
            {
                sublabel: "Hamlets", link: "/hamlets-setup"
            }
        ]
    },

]
export default SidebarData;